(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-lp-product-root]';
  var INPUT_SELECTOR = '[data-lp-option-input]';
  if (window.LupinnyProductForms && window.LupinnyProductForms.initialized === true) {
    if (typeof window.LupinnyProductForms.initAll === 'function') window.LupinnyProductForms.initAll(document);
    return;
  }

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function checkedInputs(root) {
    return all(root, '[data-lp-option] ' + INPUT_SELECTOR + ':checked').sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });
  }

  function optionGroups(root) {
    return all(root, '[data-lp-option]');
  }

  function fingerprint(inputs) {
    return inputs.map(function (input) { return input.dataset.optionValueId; }).join(',');
  }

  function button(root) {
    return root.querySelector('[data-lp-cart-button]');
  }

  function hiddenVariant(root) {
    return root.querySelector('[data-lp-variant-id]');
  }

  function cartRuntimeReady() {
    return !!(window.LUPINNY_PERSONALIZATION && window.LUPINNY_PERSONALIZATION.cartReady === true);
  }

  function hasConfirmedSelection(root) {
    var variant = hiddenVariant(root);
    var inputs = checkedInputs(root);
    return root.dataset.lpInitialized === 'true' &&
      root.dataset.committedAvailable === 'true' &&
      inputs.length === optionGroups(root).length &&
      variant && !variant.disabled && variant.value &&
      variant.value === root.dataset.committedVariantId &&
      fingerprint(inputs) === root.dataset.committedFingerprint;
  }

  function setButton(root, text, mode) {
    var cartButton = button(root);
    if (!cartButton) return;
    var textNode = cartButton.querySelector('[data-add-to-cart-text]');
    if (textNode) textNode.textContent = text;

    cartButton.removeAttribute('data-add-to-cart');
    cartButton.dataset.lpButtonMode = mode;
    cartButton.type = 'button';
    cartButton.disabled = mode === 'disabled' || mode === 'pending';

    if (mode === 'ready') {
      var form = root.querySelector('.lp-product-form');
      cartButton.disabled = true;
      if (!cartRuntimeReady() || !hasConfirmedSelection(root) || !form ||
          form.dataset.lpCartBusy || cartButton.dataset.lpBusy) return;
      cartButton.setAttribute('data-add-to-cart', '');
      cartButton.type = 'submit';
      cartButton.disabled = false;
    }
  }

  function selectionPhrase(root) {
    var noun = root.dataset.lpSelectionNoun || 'option';
    return (noun === 'option' ? 'an ' : 'a ') + noun;
  }

  function clearCommittedVariant(root) {
    var variant = hiddenVariant(root);
    if (variant) {
      variant.value = '';
      variant.disabled = true;
    }
    root.dataset.committedFingerprint = '';
    root.dataset.committedVariantId = '';
    root.dataset.committedAvailable = 'false';
  }

  function canSubmit(root) {
    var form = root.querySelector('.lp-product-form');
    var cartButton = button(root);
    return cartRuntimeReady() && hasConfirmedSelection(root) &&
      form && !form.dataset.lpCartBusy &&
      cartButton && !cartButton.disabled && !cartButton.dataset.lpBusy &&
      cartButton.dataset.lpButtonMode === 'ready';
  }

  function canSubmitForm(form) {
    var root = form && form.closest ? form.closest(ROOT_SELECTOR) : null;
    return !!(root && root.querySelector('.lp-product-form') === form && canSubmit(root));
  }

  function reconcileCartReadiness(scope) {
    var base = scope || document;
    var roots = base.matches && base.matches(ROOT_SELECTOR) ? [base] : all(base, ROOT_SELECTOR);
    roots.forEach(function (root) {
      if (root.dataset.lpInitialized !== 'true') return;
      var cartButton = button(root);
      if (!cartButton) return;
      var mode = cartButton.dataset.lpButtonMode;
      if (mode !== 'ready' && mode !== 'pending' && mode !== 'disabled') return;
      var textNode = cartButton.querySelector('[data-add-to-cart-text]');
      setButton(root, textNode ? textNode.textContent : '', mode);
    });
  }

  function updateGroupLabels(root) {
    optionGroups(root).forEach(function (group) {
      var label = group.querySelector('[data-lp-option-label]');
      var selected = group.querySelector(INPUT_SELECTOR + ':checked');
      if (label) label.textContent = selected ? selected.value : 'Select one';
    });
  }

  function updateUrlVariant(variantId) {
    var next = new URL(window.location.href);
    next.searchParams.delete('option_values');
    if (variantId) next.searchParams.set('variant', variantId);
    else next.searchParams.delete('variant');
    window.history.replaceState({}, '', next.toString());
  }

  function setStatus(root, text) {
    var status = root.querySelector('[data-lp-status]');
    if (status) status.textContent = text || '';
  }

  function hideOfferSummary(root) {
    var summary = root.querySelector('[data-lp-offer-summary]');
    if (summary) summary.hidden = true;
  }

  function updateOfferSummary(root, state) {
    var summary = root.querySelector('[data-lp-offer-summary]');
    if (!summary) return;
    var data = state && state.dataset;
    var quantity = data && Number(data.offerQuantity);
    if (!data || !Number.isInteger(quantity) || quantity < 1 || !data.offerLabel || !data.offerPerPiece) {
      summary.hidden = true;
      return;
    }
    var label = summary.querySelector('[data-lp-offer-label]');
    var perPiece = summary.querySelector('[data-lp-offer-per-piece]');
    var note = summary.querySelector('[data-lp-offer-personalization-note]');
    if (label) label.textContent = data.offerLabel;
    if (perPiece) perPiece.textContent = data.offerPerPiece;
    if (note) {
      note.textContent = data.offerPersonalizationNote || '';
      note.hidden = !data.offerPersonalizationNote;
    }
    summary.hidden = false;
  }

  function syncVariantThumb(root, media) {
    var thumb = root.querySelector('[data-lp-variant-thumb]');
    if (!thumb || !media || !media.src) return;
    thumb.dataset.mediaId = media.id || '';
    thumb.dataset.mediaSrc = media.src;
    thumb.dataset.mediaSrcSmall = media.srcSmall || media.src;
    thumb.dataset.mediaWidth = media.width || '';
    thumb.dataset.mediaHeight = media.height || '';
    thumb.dataset.mediaAlt = media.alt || '';
    thumb.dataset.mediaCaption = 'Selected color';

    var image = thumb.querySelector('img');
    if (image) {
      image.src = media.srcSmall || media.src;
      image.removeAttribute('srcset');
      image.alt = media.alt || '';
    }
  }

  function showIncomplete(root) {
    hideOfferSummary(root);
    clearCommittedVariant(root);
    setButton(root, 'Choose ' + selectionPhrase(root), 'incomplete');
    var stock = root.querySelector('[data-lp-stock]');
    if (stock) stock.textContent = 'Select ' + selectionPhrase(root);
    setStatus(root, '');
    updateUrlVariant('');
  }

  function showPending(root) {
    hideOfferSummary(root);
    clearCommittedVariant(root);
    updateUrlVariant('');
    setButton(root, 'Checking availability…', 'pending');
    var stock = root.querySelector('[data-lp-stock]');
    if (stock) stock.textContent = 'Checking…';
    setStatus(root, '');
  }

  function setHero(root, media, markThumb) {
    if (!media || !media.src) return;
    root._lpImageToken = (root._lpImageToken || 0) + 1;
    var token = root._lpImageToken;
    var stage = root.querySelector('.lp-gallery__stage');
    var hero = root.querySelector('.lp-gallery__hero-image');
    if (!hero) return;
    if (stage) stage.setAttribute('aria-busy', 'true');

    var preload = new Image();
    preload.src = media.src;
    var ready = preload.decode ? preload.decode().catch(function () {}) : new Promise(function (resolve) {
      preload.onload = resolve;
      preload.onerror = resolve;
    });

    ready.then(function () {
      if (token !== root._lpImageToken) return;
      hero.src = media.src;
      if (media.srcSmall) hero.srcset = media.srcSmall + ' 720w, ' + media.src + ' 1800w';
      if (media.alt) hero.alt = media.alt;
      if (media.width) hero.width = media.width;
      if (media.height) hero.height = media.height;
      if (stage) stage.removeAttribute('aria-busy');

      var caption = root.querySelector('[data-lp-gallery-caption]');
      if (caption) caption.textContent = media.caption || 'Selected color';

      if (!markThumb) syncVariantThumb(root, media);
      all(root, '[data-lp-thumb]').forEach(function (thumb) {
        var active = thumb.dataset.mediaId === media.id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function mediaFromDataset(dataset, prefix) {
    var p = prefix || '';
    var stem = p ? p + 'Media' : 'media';
    return {
      id: dataset[stem + 'Id'] || '',
      src: dataset[stem + 'Src'] || '',
      srcSmall: dataset[stem + 'SrcSmall'] || '',
      width: dataset[stem + 'Width'] || '',
      height: dataset[stem + 'Height'] || '',
      alt: dataset[stem + 'Alt'] || '',
      caption: dataset[stem + 'Caption'] || ''
    };
  }

  function previewColor(root, input) {
    if (!input || !input.closest('.lp-picker__group--color')) return;
    var media = mediaFromDataset(input.dataset, 'candidate');
    setHero(root, media, false);
    var price = root.querySelector('[data-lp-current-price]');
    if (price && input.dataset.candidatePrice) price.textContent = input.dataset.candidatePrice;
    var compare = root.querySelector('[data-lp-compare-price]');
    if (compare) {
      compare.textContent = input.dataset.candidateComparePrice || '';
      compare.hidden = !input.dataset.candidateComparePrice;
    }
  }

  function buildSectionUrl(root, inputs) {
    var target = new URL(root.dataset.productUrl, window.location.origin);
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, key) {
      if (key !== 'variant' && key !== 'option_values' && key !== 'section_id') {
        target.searchParams.set(key, value);
      }
    });
    target.searchParams.set('section_id', root.dataset.sectionId);
    if (inputs.length) target.searchParams.set('option_values', fingerprint(inputs));
    return target.toString();
  }

  function syncAvailability(root, sourceRoot) {
    var sourceInputs = all(sourceRoot, INPUT_SELECTOR);
    var sourceById = {};
    sourceInputs.forEach(function (input) { sourceById[input.dataset.optionValueId] = input; });

    all(root, INPUT_SELECTOR).forEach(function (input) {
      var source = sourceById[input.dataset.optionValueId];
      if (!source) return;
      var disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      input.disabled = disabled;
      if (disabled) input.setAttribute('aria-disabled', 'true');
      else input.removeAttribute('aria-disabled');

      ['candidateVariantId', 'candidateAvailable', 'candidatePrice', 'candidateComparePrice', 'candidateMediaId', 'candidateMediaSrc', 'candidateMediaSrcSmall', 'candidateMediaWidth', 'candidateMediaHeight', 'candidateMediaAlt'].forEach(function (key) {
        input.dataset[key] = source.dataset[key] || '';
      });

      var valueWrap = input.closest('[data-lp-option-value]');
      if (valueWrap) valueWrap.classList.toggle('is-unavailable', disabled);

      var unavailableLabel = valueWrap && valueWrap.querySelector('.lp-picker__unavailable-label');
      if (unavailableLabel) unavailableLabel.hidden = !disabled;

      if (disabled && input.checked) input.checked = false;
    });
  }

  function commitVariant(root, state, requestedFingerprint) {
    var variantId = state.dataset.variantId;
    var available = state.dataset.available === 'true';
    var variant = hiddenVariant(root);
    if (!variant || !variantId) return false;

    variant.value = variantId;
    variant.disabled = !available;
    root.dataset.committedFingerprint = requestedFingerprint;
    root.dataset.committedVariantId = variantId;
    root.dataset.committedAvailable = available ? 'true' : 'false';

    var price = root.querySelector('[data-lp-current-price]');
    if (price) price.textContent = state.dataset.price || '';
    var compare = root.querySelector('[data-lp-compare-price]');
    if (compare) {
      compare.textContent = state.dataset.comparePrice || '';
      compare.hidden = !state.dataset.comparePrice;
    }

    var stock = root.querySelector('[data-lp-stock]');
    if (stock) stock.textContent = available ? 'In stock' : 'Sold out';
    setButton(root, available ? 'Add to cart — ' + state.dataset.price : 'Sold out', available ? 'ready' : 'disabled');
    setStatus(root, '');
    setHero(root, mediaFromDataset(state.dataset, ''), false);
    updateOfferSummary(root, state);
    updateUrlVariant(variantId);
    return true;
  }

  function refresh(root) {
    var inputs = checkedInputs(root);
    var total = optionGroups(root).length;
    var completeBeforeRequest = inputs.length === total;
    var requestedFingerprint = fingerprint(inputs);

    if (root._lpAbort) root._lpAbort.abort();
    root._lpAbort = new AbortController();
    root._lpRequestToken = (root._lpRequestToken || 0) + 1;
    var token = root._lpRequestToken;
    showPending(root);

    fetch(buildSectionUrl(root, inputs), {
      headers: { Accept: 'text/html' },
      signal: root._lpAbort.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Variant response ' + response.status);
        return response.text();
      })
      .then(function (htmlText) {
        if (token !== root._lpRequestToken) return;
        var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
        var sourceRoot = parsed.querySelector(ROOT_SELECTOR);
        if (!sourceRoot) throw new Error('Variant section was not returned');

        syncAvailability(root, sourceRoot);
        updateGroupLabels(root);

        var currentInputs = checkedInputs(root);
        var currentFingerprint = fingerprint(currentInputs);
        var completeNow = currentInputs.length === total;
        if (!completeBeforeRequest || !completeNow) {
          showIncomplete(root);
          return;
        }

        var state = sourceRoot.querySelector('[data-lp-render-state]');
        var responseFingerprint = state ? state.dataset.optionFingerprint : '';
        if (!state || !state.dataset.variantId || responseFingerprint !== requestedFingerprint || currentFingerprint !== requestedFingerprint) {
          clearCommittedVariant(root);
          hideOfferSummary(root);
          setButton(root, 'Unavailable', 'disabled');
          var stock = root.querySelector('[data-lp-stock]');
          if (stock) stock.textContent = 'Unavailable';
          setStatus(root, 'This option combination is unavailable.');
          return;
        }

        commitVariant(root, state, requestedFingerprint);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (token !== root._lpRequestToken) return;
        clearCommittedVariant(root);
        hideOfferSummary(root);
        setButton(root, 'Try again', 'incomplete');
        var stock = root.querySelector('[data-lp-stock]');
        if (stock) stock.textContent = 'Not confirmed';
        setStatus(root, 'We could not confirm this option. Please try again.');
      });
  }

  function initRoot(root) {
    if (root.dataset.lpInitialized === 'true') return;
    root.dataset.lpInitialized = 'true';
    updateGroupLabels(root);
    var variant = hiddenVariant(root);
    var state = root.querySelector('[data-lp-render-state]');
    var inputs = checkedInputs(root);
    var selectedFingerprint = fingerprint(inputs);
    var complete = inputs.length === optionGroups(root).length;
    if (complete && variant && state && state.dataset.variantId &&
        variant.value === state.dataset.variantId &&
        selectedFingerprint === state.dataset.optionFingerprint) {
      var available = state.dataset.available === 'true';
      variant.disabled = !available;
      root.dataset.committedFingerprint = state.dataset.optionFingerprint;
      root.dataset.committedVariantId = state.dataset.variantId;
      root.dataset.committedAvailable = available ? 'true' : 'false';
      setButton(root, available ? 'Add to cart — ' + state.dataset.price : 'Sold out', available ? 'ready' : 'disabled');
      updateOfferSummary(root, state);
    } else if (complete) {
      refresh(root);
    } else {
      showIncomplete(root);
    }
  }

  function initAll(scope) {
    var base = scope || document;
    if (base.matches && base.matches(ROOT_SELECTOR)) initRoot(base);
    all(base, ROOT_SELECTOR).forEach(initRoot);
  }

  window.LupinnyProductForms = window.LupinnyProductForms || {};
  window.LupinnyProductForms.canSubmit = canSubmitForm;
  window.LupinnyProductForms.initAll = initAll;
  window.LupinnyProductForms.initialized = true;

  document.addEventListener('lupinny:cart-ready', function () { reconcileCartReadiness(document); });
  document.addEventListener('lupinny:cart-error', function (event) {
    var form = event.detail && event.detail.form;
    var root = form && form.closest ? form.closest(ROOT_SELECTOR) : null;
    if (root && root.querySelector('.lp-product-form') === form) reconcileCartReadiness(root);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest(INPUT_SELECTOR);
    if (!input) return;
    var root = input.closest(ROOT_SELECTOR);
    if (!root) return;
    updateGroupLabels(root);
    previewColor(root, input);
    clearCommittedVariant(root);
    refresh(root);
  });

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-lp-thumb]');
    if (thumb) {
      var galleryRoot = thumb.closest(ROOT_SELECTOR);
      if (galleryRoot) setHero(galleryRoot, mediaFromDataset(thumb.dataset, ''), true);
      return;
    }

    var cartButton = event.target.closest('[data-lp-cart-button]');
    if (!cartButton || cartButton.hasAttribute('data-add-to-cart')) return;
    event.preventDefault();
    if (cartButton.disabled || cartButton.dataset.lpBusy || cartButton.dataset.lpButtonMode === 'pending') return;
    var root = cartButton.closest(ROOT_SELECTOR);
    if (!root) return;
    var missing = optionGroups(root).find(function (group) {
      return !group.querySelector(INPUT_SELECTOR + ':checked');
    });
    if (missing) {
      missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusTarget = missing.querySelector(INPUT_SELECTOR + ':not(:disabled)');
      if (focusTarget) window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 350);
      setStatus(root, 'Please choose ' + selectionPhrase(root) + ' before adding this item.');
      return;
    }

    refresh(root);
  });

  window.addEventListener('click', function (event) {
    var cartButton = event.target.closest('[data-lp-cart-button]');
    if (!cartButton || !cartButton.hasAttribute('data-add-to-cart')) return;
    var root = cartButton.closest(ROOT_SELECTOR);
    if (!root || canSubmit(root)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cartButton.disabled || cartButton.dataset.lpBusy) return;
    refresh(root);
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target.closest('.lp-product-form');
    if (!form) return;
    var root = form.closest(ROOT_SELECTOR);
    if (!root) return;
    if (!canSubmit(root)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setStatus(root, 'Please confirm your selections before adding this item.');
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  initAll(document);
})();
